export default __webpack_public_path__ + "static/media/avatar-2.328d0779.png";